import { useEffect } from 'react';
import { useExitIntent as useBaseUseExitIntent } from 'use-exit-intent';
import Cookies from 'js-cookie';
import { useExitIntentPopup } from './useExitIntentPopup';

type UseExitIntentProps = {
  isExitIntentEnabled?: boolean;
};

function getIsBrowser() {
  return typeof window !== 'undefined';
}

const useExitIntent = ({ isExitIntentEnabled }: UseExitIntentProps) => {
  const modal = useExitIntentPopup();

  const { unsubscribe, registerHandler } = useBaseUseExitIntent({
    cookie: { key: 'mv_exit_intent_shown', daysToExpire: 14 },
    desktop: {
      delayInSecondsToTrigger: 20,
      triggerOnMouseLeave: true,
      triggerOnIdle: true,
      useBeforeUnload: false,
    },
    mobile: { delayInSecondsToTrigger: 20, triggerOnIdle: true },
  });

  const isUserAuthenticated = () => {
    return Cookies.get('squanchy');
  };

  const initializeExitIntent = () => {
    if (!isExitIntentEnabled || isUserAuthenticated()) {
      return;
    }
    registerHandler({
      id: 'exitIntent',
      handler: () => {
        modal.show();
        unsubscribe();
      },
    });
  };

  if (getIsBrowser()) {
    initializeExitIntent();
  }
};

export default useExitIntent;
